import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupItemsApi = {
    getTrialGroupItemById: (id: number): Observable<Dtos.GetTrialGroupItemByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemById = new Dtos.GetTrialGroupItemById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupItemsByTrialGroupId: (id: number): Observable<Dtos.GetTrialGroupItemsByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemsByTrialGroupId = new Dtos.GetTrialGroupItemsByTrialGroupId();

        request.trialGroupId = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemsByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupItem: (trialGroupItem: Dtos.TrialGroupItem, _collection: Dtos.Collection): Observable<Dtos.SetTrialGroupItemResponse> => {
        let request: Dtos.SetTrialGroupItem = new Dtos.SetTrialGroupItem();

        request.trialGroupItem = trialGroupItem;
        // request.collection = collection;

        // send request
        const response: Promise<Dtos.SetTrialGroupItemResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialGroupItem: (trialGroupId: number): Observable<Dtos.CreateTrialGroupItemResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupItem = new Dtos.CreateTrialGroupItem();

        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupItemResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}